import type { JobRoleSelectDto, JobRolesSelectDto } from '@@types/api.types';
import { useAuth0 } from '@auth0/auth0-react';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './keys';

export const useGetJobRoles = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = Boolean(isAuthenticated);

  return useQuery<JobRoleSelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<JobRolesSelectDto>({
        path: '/v1/data/job-roles',
      });
      return result.jobRoles;
    },
    queryKey: enabled ? queryKeys.jobRoles.getJobRoles : queryKeys.placeholders.default,
  });
};
